
define('text!common/views/commercial/creatives/fabric-expanding-video.html',[],function () { return '<iframe\n    width="<%=width%>"\n    height="<%=height%>"\n    src="<%=src%>"\n    frameborder="0"\n    class="<%=className%>"\n    style="<%=inlineStyle%>">\n</iframe>\n';});

